// extracted by mini-css-extract-plugin
module.exports = {"cadArrestsInformation":"CadArrestsInformation_cadArrestsInformation__1XWDr","title":"CadArrestsInformation_title__jLU0Z","items":"CadArrestsInformation_items__7jYp3"};